import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.episodeFact') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.episodeFact') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.episodeFact') })
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.episodeFact') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.episodeFact') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.episodeFact') });
});